import '@operato/i18n/ox-i18n.js'
import '@material/web/checkbox/checkbox.js'

import { css, html, LitElement } from 'lit'
import { customElement, property } from 'lit/decorators.js'

import { i18next, localize } from '@operato/i18n'
import { clientSettingStore } from '@operato/shell'
import { setupContextUIPart } from './index'

@customElement('title-on-page-header-setting-let')
export class TitleOnPageHeaderSettingLet extends localize(i18next)(LitElement) {
  static styles = [
    css`
      label {
        display: flex;
        gap: 10px;
        align-items: center;

        font: var(--label-font);
        color: var(--md-sys-color-on-primary-container);
        text-transform: var(--label-text-transform);
      }
    `
  ]

  @property({ type: Boolean }) show: boolean = false

  render() {
    const checked = this.show === true

    return html`
      <setting-let>
        <ox-i18n slot="title" msgid="title.title-on-page-header setting"></ox-i18n>

        <div slot="content">
          <label>
            <md-checkbox @change=${e => this.onChangeContextOnPage(e)} ?checked=${checked}></md-checkbox>
            ${i18next.t('label.show-title-on-page-header')}
          </label>
        </div>
      </setting-let>
    `
  }

  async firstUpdated() {
    this.show = ((await clientSettingStore.get('title-on-page-header'))?.value || {}).show
  }

  async onChangeContextOnPage(e) {
    const show = e.currentTarget.checked

    try {
      await clientSettingStore.put({
        key: 'title-on-page-header',
        value: {
          show
        }
      })
    } catch (e) {
      console.error(e)
    }

    setupContextUIPart({
      titlebar: show ? 'page-header' : 'header'
    })
  }
}
